<template>
<div class="container">
<mt-navbar v-model="selected" :fixed="true" style="top:3.1rem;">
  <mt-tab-item id="all">汇总分析</mt-tab-item>
  <mt-tab-item id="fc">复查计划</mt-tab-item>
  <mt-tab-item id="jk">指标监控</mt-tab-item>
  <mt-tab-item id="detail">报告详情</mt-tab-item>
  <i class="fa fa-angle-down more blue" @click="showtype" v-show="allLoaded"></i>
</mt-navbar>


<!-- tab-container -->
<mt-tab-container v-model="selected" style="margin-top:3.5rem;">
  <mt-tab-container-item id="all">
    <div class="express">
        <div>
            <a :href="pdf" v-show="pdf" class="download" download>下载PDF报告</a>
            <a class="download" @click="show_express=!show_express" v-if="had_print==false">纸质报告</a>
        </div>
        <div class="express-form" v-show="show_express">
            <select v-model="express.express_lb">
                <option value="取消报告">取消纸质报告</option>
                <option value="上门自取">上门自取（提前1天）</option>
                <option value="顺丰到付">顺丰到付</option>
            </select>
            <input type="text" placeholder="收件人姓名" v-model="express.express_xm" v-show="express.express_lb=='顺丰到付'">
            <input type="text" placeholder="收件人手机号码" v-model="express.express_dh" v-show="express.express_lb=='顺丰到付'">
            <input type="text" placeholder="联系地址" v-model="express.express_dz" v-show="express.express_lb=='顺丰到付'">
            <button class="express-sub" @click="express_sub">确 定</button>
        </div>
    </div>
    <div class="myitem" v-for="(v,i) in bg.all" :key="v.id" v-show="!show_express">
    	<div class="row bluetitle">{{i+1}}. {{v.jl}}</div>
    	<div class="row body" v-html="v.jy"></div>
    </div>
  </mt-tab-container-item>


  <mt-tab-container-item id="fc">
  <div class="row mt center bwhite" v-if="!bg.fc||bg.fc=='nothing'" style="padding:.5rem;">暂无复查计划</div>

  <div class="row bluetitle mt" v-if="bg.fc&&bg.fc!='nothing'">
  	<div class="col-7 center">复查项目</div>
  	<div class="col-3 center">复查时间</div>
  </div>

  <div class="row fctime" v-for="(time,timei) in bg.fc" v-show="bg.fc&&bg.fc!='nothing'" :key="time.id">
  	<div class="col-7">
  		<div class="row" v-for="(bm,bmi) in time" :key="bm.id">
  			<div class="col-3 center bbg rb bb" :style="{height:mh*bm.length+'rem',lineHeight:mh*bm.length+'rem'}">{{bmi}}</div>
  			<div class="col-7">
  				<div class="row mh bbg bb rb" v-for="v in bm" :key="v.id">{{v}}</div>
  			</div>
  		</div>
  	</div>
  	<div class="col-3 bbg" :style="{height:mh*fclen(time)+'rem',lineHeight:mh*fclen(time)+'rem'}">
  		{{timei|strtime}}
  	</div>
  </div>

  </mt-tab-container-item>



  <mt-tab-container-item id="jk">
    <div class="row bluetitle mt" style="padding:0;" v-if="bg.jk.length>0">
    	<div class="col-2 l2 center">本次结果</div>
    	<div class="col-6" style="border-right:2px solid white;border-left:2px solid white;">
    	 <div class="row center" style="height:1.5rem;line-height:1.5rem;">历史检查结果</div>
    	 <div class="row"  style="height:1.5rem;line-height:1.5rem;border-top:2px solid white;">
    	 	<div class="col-25 center"><small>{{bg.jk[0].t1|month}}</small></div>
    	 	<div class="col-25 center"><small>{{bg.jk[0].t2|month}}</small></div>
    	 	<div class="col-25 center"><small>{{bg.jk[0].t3|month}}</small></div>
    	 	<div class="col-25 center"><small>{{bg.jk[0].t4|month}}</small></div>
    	 </div>
    	</div>
    	<div class="col-2 l2 center">正常值</div>
    </div>

    <span v-for="v in bg.jk" v-show="v.v0" :key="v.id">
	    <div class="row bbg">
	    	<div class="col-4 blue" style="padding-left:.5rem;"><small>{{v.mc}}</small></div>
	    	<div class="col-6 tr gray" style="padding-right:.5rem;"><small>{{v.memo}}</small></div>
	    </div>
	    <div class="row pd bwhite">
	    	<div class="col-2 blue" :style="{paddingLeft:'0.3rem',color:(v._r0!==''&&v._r0!=='N')?'red':''}">{{v.v0|zb}}</div>
	    	<div class="col-15 gray center">{{v.v1|zb}}</div>
	    	<div class="col-15 gray center">{{v.v2|zb}}</div>
	    	<div class="col-15 gray center">{{v.v3|zb}}</div>
	    	<div class="col-15 gray center">{{v.v4|zb}}</div>
	    	<div class="col-2 gray center">{{v.dw}}</div>
	    </div>
    </span>


  </mt-tab-container-item>


<mt-tab-container-item id="detail"
    v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="allLoaded"
    infinite-scroll-distance="10">

<div class="row myitem bwhite" v-for="v in bg.detail.data" v-if="bg.detail.count>0" :key="v.id">

  <div class="row bwhite center pd blue" :id="'type'+v.jgid">{{v.wpmc}}({{v.lb}})</div>


  <div :class="{row:true,bluetitle:true,center:v.tjjg[0]['def']}">
  	<div class="col-3">检查项目</div>
  	<div :class="{'col-5':v.tjjg[0]['def'],'col-7':!v.tjjg[0]['def']}">检查结果</div>
  	<div class="col-2" v-show="v.tjjg[0]['def']">参考范围</div>
  </div>

   <div class="row pt" v-show="v.checkimage=='True'&&v.pacsimage.length>0">
        <div class="col-5" v-for="vv in v.pacsimage" @click="showbigimage(vv)" :key="vv.id">
        <img :src="'data:image/jpeg;base64,'+vv.img" title="查看大图" class="img">
        </div>
   </div>

  <div :class="{row:true,center:v.tjjg[0]['def'],bbg:i%2==0,pd:true}" v-for="(vv,i) in v.tjjg" v-show="vv.value" :key="vv.id">
  	<div class="col-3 pl" @click="gethistory(vv)">{{vv.mc}}</div>
  	<div :class="{'col-5':v.tjjg[0]['def'],'col-7':!v.tjjg[0]['def'],red:isHeight(vv.result)==1,blue:isHeight(vv.result)==-1}">
        <span v-if="vv.pre">{{vv.pre}}</span>
        {{format(vv.value,vv.format)}}
        {{vv.dw}}
    </div>
  	<div class="col-2" v-show="v.tjjg[0]['def']"><small>{{vv.def}}</small></div>
  </div>

  <div class="row pl" style="border-top:1px solid #eee;">
  	 <b>结论：</b>
     <p v-for="(j,jlindex) in v.jl" class="red" :key="j.id">
        <span v-show="v.jl.length>1">{{jlindex+1}}.</span>{{j.jl}}
     </p>
  </div>
  <div class="row tr pr">
  	检查医生：
  	<span v-if="!v.qmimage" class="blue">{{v.ys}}</span>
  	<img :src="'data:image/png;base64,'+v.qmimage" :alt="v.js" v-if="v.qmimage" style="width:5rem;"/>
  </div>
  <!-- <div class="row tr pr">{{v.tjsj}}</div> -->

</div>
<div class="row center" style="padding:1rem;" v-show="!allLoaded">
   <mt-button size="small" @click="loadBottom">查看更多</mt-button>
</div>

</mt-tab-container-item>

</mt-tab-container>

<mt-popup v-model="showpic" style="width:100%;">
    <img :src="'data:image/jpeg;base64,'+bigpic" alt="图片加载中" style="width:100%;">
</mt-popup>

<mt-popup v-model="showhis" class="his">
   <div class="row center bluetitle histitle" v-if="history.my" @click="closehis">
   	 <h3><i class="fa fa-angle-left back"></i>{{history.my.title}}-历史体检结果</h3>
   </div>

	<div class="row" style="margin-top:2rem;border-top:1px solid #eee;">
		<div class="col-3">体检时间</div>
		<div class="col-7">体检结果</div>
	</div>
	<div class="row" v-for="v in history.data" :key="v.id">
		<div class="col-3">{{v.tjsj|strtime}}</div>
		<div class="col-7">{{v.value}} {{history.my.dw}}</div>
	</div>
</mt-popup>

<mt-actionsheet :actions="types" v-model="typestatus"></mt-actionsheet>

</div>
</template>

<style scoped>
.container{background: rgb(251,251,251);}
.col-25{padding:0;}
.col-15{float:left;width:15%;min-height: 1px;padding:.2rem 0;}
.col-7,.col-3{padding:0;}
.bbg{background: rgb(237,247,255);}
.myitem{margin:.5rem 0;background:white;float: left;padding:.5rem 0;}
.bluetitle{background:rgb(0,144,255);color:white;padding:.3rem; }
.body{padding:.5rem 1rem;}
.mt{margin-top: .5rem;}
.mh{height:1.8rem;line-height: 1.8rem;}

.fctime{margin:.5rem 0;}

.rb{border-right:2px solid white;}
.bb{border-bottom: 2px solid white;}
.tr{text-align: right;}
.pd{padding:.3rem 0;}
.pt{padding:.5rem 0 .3rem;}
.pl{padding-left: .3rem;}
.pr{padding-right: .3rem;}
.l2{line-height:3rem;height:3rem;}
.gray{color:#adadad;}
.blue{color:rgb(0,144,255);}
.red{color:red;}
.bwhite{background: white;}
.img{width:96%;margin:2%;height:auto;height:10rem;}

.his{width:100%;height:100%;}
.his .col-3,.his .col-7{padding:.5rem;}
.his .col-7{border-left:1px solid #eee;}
.his .row{border-bottom: 1px solid #eee;}
.histitle i{float:left;font-size:1.3rem;}

.more{line-height: 3rem;font-size: 1.5rem;padding:.1rem;}
.detail-wrap{
    height:83vh;
    overflow: auto;
    float:left;
}
.mint-loadmore-content{
    float:left;
}
.express{
    padding:1rem 0 .3rem;
}
.download{
    padding:.5rem .7rem;
    border:1px solid #ddd;
    border-radius: .2rem;
    margin:0 .5rem 0 .3rem;
    font-size:.9rem;
}
.express-form{
    width:90%;
    margin:1rem 5%;
    border:1px solid #ddd;
    padding:.5rem;
    border-radius: .5rem;
}
.express-form input,.express-form select{
    display: block;
    margin-top:.5rem;
    width:100%;
    padding:.3rem .5rem;
    min-height: 34px;
}
.express-sub{
    width:100%;
    padding:.5rem;
    min-height: 30px;
    margin:.5rem 0;
}
</style>

<script>
import { InfiniteScroll } from 'mint-ui';

export default {
    components:{InfiniteScroll},
	data:function(){
		return {
            selected:"all",
            bg:{
                all:"",
                fc:"",
                jk:"",
                detail:""
            },
            bigpic:"",
            showpic:false,
            history:"",
            showhis:false,
            fun:fun,
            mh:1.8,
            allLoaded:false,
            types:[],
            typestatus:false,
            loading:false,
            api:mydata.api+"Report/",
            status:"",
            pdf:"",
            had_print:true,
            express:{
                tjid:0,
                express_lb:'上门自取',
                express_xm:"",
                express_dh:"",
                express_dz:"",
                cancel:0,
            },
            show_express:false,
            tjid:0,
		}
	},
	filters:{
		zb:function(num){
			 num=num.toString();
			 var dian=num.indexOf(".");
			 if(dian==-1){return num;}
			 var _int=num.substring(0,dian);
			 var _float=num.substring(dian+1);
			 if(_float.length>3){_float=_float.substring(0,3);}
			 return _int+"."+_float;
		},
	},
	watch:{
	  selected:function(d){
             this.status=d;
			if(d!="all"){this.getli(d);}
		}
	},
	created:function(){
		this.init();
	},
	methods:{
	 init:function(){
        this.$emit("setTitle","体检报告查询");
        var _this=this;
        var data={
        	tjid:this.$route.params.id,
        };
        this.tjid=data.tjid;
        fun.post(this.api+"get_hz",data,function(d){
        	console.log(d);
        	if(d.status==1){
        		_this.bg.all=d.info.hz;
        		_this.express=d.info.express;
                _this.pdf=d.info.pdf;
                _this.had_print=d.info.had_print;
        	}else{
                _this.$toast(d.info);
                if(d.info=="报告正在制作中，请过几天再试"){
                    history.back();
                }
        	}
        })
	 },
     express_sub(){
         var data=this.express;
         data.tjid=this.tjid;
         if(data.express_lb=='顺丰到付'){
             if(!data.express_xm){
                 this.$toast("请填写收件人姓名");
                 return;
             }
             if(data.express_dh.length!=11){
                 this.$toast("请填写正确的手机号码");
                 return;
             }
             if(!data.express_dz){
                 this.$toast("请填写联系地址");
                 return;
             }
         }
         fun.post(this.api+"express_sub",data,d=>{
             console.log(d);
             if(d.status==1){
                 this.$toast("提交成功");
                 this.show_express=false;
             }else{
                 this.$toast(d.info);
             }
         })
     },
   showtype:function(){
        var _this=this;
        var data={
            tjid:this.$route.params.id,
        };
        if(this.types.length>0){
        this.typestatus=true;return;
        }
        fun.post(this.api+"get_dir",data,function(d){
            console.log(d);
            if(d.status==1){
            var len=d.info.length;
            var re=[];
            for(var i=0;i<len;i++){
                var tem=d.info[i];
                tem.name=tem.wpmc;
                tem.method=_this.settype;
                re.push(tem);
            }
            _this.types=re;
            _this.typestatus=true;
            }
        })
   },
   settype:function(d){
        var anchor = this.$el.querySelector("#type"+d.jgid);
        window.scrollTo(0,anchor.offsetTop);
        //this.detailAll();
   },
    getli:function(type){
        if(this.bg[type]){return;}
        var _this=this;
        var data={
            tjid:this.$route.params.id,
            type:type,
        };
        fun.post(this.api+"getli",data,function(d){
            console.log(d);
            if(d.status==1){
                if(type=="fc"){
                    if(d.info.length>0){
                        _this.bg.fc=_this.formatfc(d.info);
                    }else{
                        _this.bg.fc="nothing";
                    }
                }else{
                    _this.bg[type]=d.info;
                if(type=="detail"){
                // _this.detailAll();
                _this.loadBottom("auto");
                }
                }
            }else{
                _this.$toast(d.info);
            }
        })
    },
    //暂时未启用
   detailAll:function(){
     var _this=this;
     var data={
        tjid:this.$route.params.id,
        total:this.bg.detail.count,
      };
     fun.post(this.api+"detail_all",data,function(d){
        console.log(d);
        if(d.status==1){
          _this.bg.detail=d.info;
          _this.allLoaded=true;
        }else{
          _this.$toast(d.info);
        }
      },true)
   },
   formatfc:function(fc){
      var re={};
      var len=fc.length;
      for(var i=0;i<len;i++){
      	var item=fc[i];
      	var fcsj=item.fcsj;
      	var bmmc=item.bmmc;
      	var wpmc=item.wpmc;
      	if(!re[fcsj]){re[fcsj]={};}
      	if(!re[fcsj][bmmc]){re[fcsj][bmmc]=[];}
      	re[fcsj][bmmc].push(wpmc);
      }
      return re;
	 },
	fclen:function(sj){
      var len=0;
      for(var i in sj){
      	len+=sj[i].length;
      }
      return len;
	 },
	 loadBottom:function(e){
      if(this.status!="detail"){
          return;
      }
      if(!this.bg||!this.bg.detail||!this.bg.detail.data){
          return;
      }
      if(this.bg.detail.data.length>=this.bg.detail.count){
          this.allLoaded=true;
          if(e!="auto"){this.$toast("没有更多了")};
          return;
      }
       var showloading=e=="auto"?true:false;
       if(e!="auto"&&this.loading){return;}

       var data={
        	tjid:this.$route.params.id,
        	len:this.bg.detail.data.length,
        };
        var _this=this;
        this.loading=true;
        fun.post(this.api+"detail_more",data,function(d){
          console.log(d);
           _this.loading=false;
        	if(d.status==1){
              _this.bg.detail.data=_this.bg.detail.data.concat(d.info);
            //   _this.loadBottom("auto");
        	}else{
             _this.$toast(d.info);
        	}
        },showloading)
	 },
	 isHeight:function(d){
      if(d=="L"||d=="L-"||d=="L--" || d=="-"){
      	return -1;
      }else if(d=="H"||d=="H+"||d=="H++" ||d=="+" ||d=="+-"){
      	return 1;
      }else{
      	return 0;
      }
	 },
   showbigimage:function(d){
      var data={
      	imageid:d.imageid,
      }
      var _this=this;
     fun.post(this.api+"bigpic",data,function(d){
     	console.log(d);
     	if(d.status==1){
     		_this.bigpic=d.info;
     		_this.showpic=true;
     	}else{
     		_this.$toast(d.info);
     	}
     })
     },
     gethistory:function(v){
      var _this=this;
      var data={
      	xmid:v.xmid,
      }
      if(!data.xmid){return;}
      fun.post(this.api+"gethistory",data,function(d){
      	 console.log(d);
      	 if(d.status==1){
      	 	_this.history=d.info;
      	 	_this.showhis=true;
      	 }else{
      	 	_this.$toast(d.info);
      	 }
      })
     },
     closehis:function(){
     	this.showhis=false;
     },
     format:function(str,f){
       if(!f||!str){return str;}
       if(!str.match(/\d+/)){
            return str;
        }
       var num=new Number(str);
       if(f=="#,##0.0"){
         var re=num.toFixed(1);
       }else if(f=="#,##0.0#"){
         var re=parseFloat(num.toFixed(2));
       }else if(f=="#,##0.00"){
         var re=num.toFixed(2);
       }else if(f=="#,##0"){
        return this.qianfen(parseInt(num));
       }else{
        return str;
       }
      re=re.toString();
      var l=this.qianfen(re.split('.')[0]);
      if(re.split(".").length<2){return l;}

      var r = re.split('.')[1];
      return l + '.' + r;
    },
    qianfen:function(int){
        var l=int.toString().split('').reverse();
        var t="";
        for (var i = 0; i < l.length; i++){
            t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? ',' : '');
        }
        return t.split('').reverse().join('');
    }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/user/report_detail.vue